import React from 'react';

import { Paper } from '@mui/material';
import { MobileList, FlexTable, FlexTableColumn, TableColumn } from '@uplift/ui-v2';

import { PatientServiceItem } from '@uplift/api';
import { ModalServiceDetailsComponent, TableServiceDetailsComponent } from './ServiceDetails';
import { mobileBreakpoint, useIsMobile } from '@uplift/hooks';


export type ResponsivePaymentsTableProps<T extends PatientServiceItem> = {
  columns: {
    desktop: FlexTableColumn<T>[];
    mobile: TableColumn<T>[];
  };
  rows: T[];
};


export function ResponsivePaymentsTable<T extends PatientServiceItem>(props: ResponsivePaymentsTableProps<T>) {
  const isMobile = useIsMobile(mobileBreakpoint);

  if (isMobile) {
    return (
      <MobileList
        rowDetailsComponent={ModalServiceDetailsComponent}
        columns={props.columns.mobile}
        rows={props.rows}
      />
    );
  }

  return (
    <Paper elevation={1}>
      <FlexTable
        getRowId={(row) => row.id}
        rowsPerPageOptions={[ props.rows.length ]}
        columns={props.columns.desktop}
        rows={props.rows}
        hidePagination
        rowDetailsContent={TableServiceDetailsComponent}
        expandButtonPlacement="end"
      />
    </Paper>
  );
}
